'use client';

import { useState, useEffect } from 'react';
import ContactForm from './ContactForm';
import ContactFormDE from './ContactFormDE';

interface ContactInteractiveProps {
  lang?: 'en' | 'de';
}

const ContactInteractive = ({ lang = 'en' }: ContactInteractiveProps) => {
  const [currentLanguage, setCurrentLanguage] = useState<'en' | 'de'>(lang);

  useEffect(() => {
    // Update language if prop changes
    setCurrentLanguage(lang);

    const handleLanguageChange = (event: Event) => {
      const lang = (event as CustomEvent<{ language: 'en' | 'de' }>).detail?.language;
      if (lang) {
        setCurrentLanguage(lang);
      }
    };

    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange as EventListener);
    };
  }, []);

  const translations = {
    en: {
      title: 'Get In Touch',
      subtitle: (
        <>
          Ready to start your business boost?
          <br />
          Reach out and let's create something extraordinary together.
        </>
      ),
    },
    de: {
      title: 'Kontakt aufnehmen',
      subtitle: (
        <>
          Bereit, Ihr Geschäft anzukurbeln?
          <br />
          Nehmen Sie Kontakt auf und lassen Sie uns gemeinsam etwas Außergewöhnliches schaffen.
        </>
      ),
    },
  };

  const t = translations[currentLanguage];

  return (
    <div className="container mx-auto px-4 pt-32 pb-16 max-w-4xl">
      {/* Header Section */}
      <div className="text-center mb-16">
        <h1 
          className="text-4xl md:text-5xl font-bold mb-6"
          style={{
            fontFamily: '"Exo 2", sans-serif',
            color: '#00b8ff'
          }}
        >
          {t.title}
        </h1>
        <p 
          className="text-3xl font-semibold max-w-3xl mx-auto"
          style={{
            fontFamily: '"Exo 2", sans-serif',
            color: '#16c55f'
          }}
        >
          {t.subtitle}
        </p>
      </div>

      {/* Contact Form */}
      <div className="max-w-2xl mx-auto">
        {currentLanguage === 'de' ? <ContactFormDE /> : <ContactForm />}
      </div>
    </div>
  );
};

export default ContactInteractive;